import { jsx as r } from "react/jsx-runtime";
import * as n from "react";
import { c as d } from "../../utils-BOFVZgHd.js";
const l = n.forwardRef(
  ({ className: e, error: o, resize: a = "vertical", ...t }, i) => {
    const s = {
      none: "resize-none",
      vertical: "resize-y",
      horizontal: "resize-x",
      both: "resize"
    }[a];
    return /* @__PURE__ */ r("div", { className: "relative w-full", children: /* @__PURE__ */ r(
      "textarea",
      {
        className: d(
          "flex min-h-[100px] w-full rounded-md border px-3 py-2 text-sm",
          "bg-[var(--input)] text-[var(--foreground)] placeholder:text-[var(--muted-foreground)]",
          "focus:ring-2 focus:ring-[var(--ring)] focus:ring-offset-0",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          "transition-colors duration-200",
          s,
          o ? "border-[var(--destructive)] ring-1 ring-[var(--destructive)]" : "border-[var(--border)]",
          e
        ),
        ref: i,
        ...t
      }
    ) });
  }
);
l.displayName = "Textarea";
export {
  l as Textarea
};
//# sourceMappingURL=textarea.js.map
